"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var FormControl_1 = __importDefault(require("../../../Components/Atoms/FormControl"));
var Input_1 = __importDefault(require("../../../Components/Atoms/Input"));
var InputLabel_1 = __importDefault(require("../../../Components/Atoms/InputLabel"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeDropDownSelectStyling_1 = __importDefault(require("./makeDropDownSelectStyling"));
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = require("@emotion/react");
var DropDownSelect = function (_a) {
    var children = _a.children, disabled = _a.disabled, errorMessage = _a.errorMessage, iconType = _a.iconType, id = _a.id, label = _a.label, onChange = _a.onChange, onClick = _a.onClick, onBlur = _a.onBlur, value = _a.value, inputRef = _a.inputRef, experimentName = _a.experimentName;
    var styles = (0, makeDropDownSelectStyling_1.default)({
        isIconPresent: iconType !== 'none',
        isDisabled: disabled,
        isError: !!errorMessage,
    });
    var StyledInputLabel = (0, styled_1.default)(InputLabel_1.default)(styles.label);
    var StyledFormControl = (0, styled_1.default)(FormControl_1.default)(styles.formControl);
    var InputElement = ((0, jsx_runtime_1.jsx)(Input_1.default, { id: id, disabled: disabled, iconType: iconType === 'none' ? undefined : iconType, onChange: onChange, onClick: onClick, onBlur: onBlur, value: value, inputRef: inputRef, experimentName: experimentName }));
    return ((0, jsx_runtime_1.jsxs)(StyledFormControl, __assign({ error: !!errorMessage, experimentName: experimentName }, { children: [value === '' && ((0, jsx_runtime_1.jsx)(StyledInputLabel, __assign({ htmlFor: id, shrink: false, experimentName: experimentName }, { children: label }))), (0, jsx_runtime_1.jsx)(Select_1.default, __assign({ variant: "standard", IconComponent: ExpandMore_1.default, MenuProps: {
                    classes: { paper: 'dropdown-paper' },
                }, input: InputElement }, { children: children })), errorMessage && (0, jsx_runtime_1.jsx)(FormHelperText_1.default, { children: errorMessage }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: styles.listItems })] })));
};
DropDownSelect.defaultProps = defaultProps_1.default;
exports.default = DropDownSelect;
//# sourceMappingURL=DropDownSelect.js.map